import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { ReactiveFormsModule } from '@angular/forms'

import { MaterialModule } from '../material/material.module'
import { TaxCodeModule } from '../tax-code/tax-code.module'
import { UiModule } from '../ui/ui/ui.module'
import { TicPage } from './pages/tic/tic.page'
import { PublicTicViewRoutesModule } from './routes/public-tic-view.routes'

@NgModule({
  declarations: [TicPage],
  imports: [
    CommonModule,
    PublicTicViewRoutesModule,
    MaterialModule,
    UiModule,
    ReactiveFormsModule,
    TaxCodeModule,
  ],
})
export class PublicTicViewModule {}
